import React from 'react';

import { Modal, Tabs } from 'antd/lib';
import { graphql, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import getLicenciaPorId from '../../../graphql/querys/rrhh/getLicenciaPorId.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import DatosLicencia from './tabs/DatosLicencia';
import DatosEvaluacion from './tabs/DatosEvaluacion';

const TabPane = Tabs.TabPane;

@graphql(getUsuario)
class EvaluarLicencia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      filtro: '',
      licencia: {},
    };

    this.props.client
      .query({
        query: getLicenciaPorId,
        variables: {
          _id: this.props.match.params.id,
        },
      })
      .then(res => {
        let licencia = res.data.getLicenciaPorId;
        if (licencia) {
          this.setState({
            ...this.state,
            loading: false,
            licencia: licencia,
          });
        }
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  render() {
    const { usuario } = this.props;

    if (this.state.loading) {
      return <Loading />;
    }

    if (
      this.state.licencia &&
      this.state.licencia.aprobacionFase1 &&
      this.state.licencia.aprobacionFase2 &&
      (this.props.usuario._id != this.state.licencia.superior._id ||
        (usuario.rol !== 'DGJP_DIRECTOR' && usuario.rol !== 'DGJP_EMPLEADO'))
    ) {
      this.props.history.push('/rrhh/licencias');
    }

    return (
      <Tabs defaultActiveKey="evaluacion">
        <TabPane tab="Datos Licencia" key="licencia">
          <DatosLicencia licencia={this.state.licencia} />
        </TabPane>
        <TabPane tab="Datos Evaluacion" key="evaluacion">
          <DatosEvaluacion
            licencia={this.state.licencia}
            history={this.props.history}
          />
        </TabPane>
      </Tabs>
    );
  }
}

export default withApollo(EvaluarLicencia);
